<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5NWMeq/tc-custom/9781611520156.jpg?1723404796647" alt="This image is the cover for the book Opening Day at the County Fair"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Opening Day at the County Fair
      </h1>
      <p class="bookDescription body article font2">
        <p>Jesse's a freeloader according to his father, a man he'll never please. Working on the farm is hard work and getting ready for the county fair a welcome respite from the daily grind. There he meets Davis.<br/><br/>The son of a local contractor, Davis is helping assemble the booths. He catches Jesse's attention immediately, and the two hit it off. If only they can ditch Jesse's sister long enough to get to know each other a little better ...</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J.M. Snyder
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JMS Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?19859160